/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export { NzSliderComponent } from './slider.component';
export { NzSliderService as ɵNzSliderService } from './slider.service';
export { NzSliderModule } from './slider.module';
export { NzSliderHandleComponent as ɵNzSliderHandleComponent } from './handle.component';
export { NzSliderMarksComponent as ɵNzSliderMarksComponent } from './marks.component';
export { NzSliderStepComponent as ɵNzSliderStepComponent } from './step.component';
export { NzSliderTrackComponent as ɵNzSliderTrackComponent, NzSliderTrackStyle } from './track.component';
export * from './typings';
